

import {
  Box,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Button,
  List,
  ListItem,
  ListItemButton,
  AppBar,
  ListItemText,
} from "@mui/material";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import "../styles/Services.css";
import { Helmet } from "react-helmet-async";

import { servicesData } from "./servicesData";

const Services = () => {
  return (
    <>
      <Helmet>
        <title>Services | KRM Landscape</title>
        <meta
          name="description"
          content="Explore professional landscaping services by KRM Landscape including garden care, plant supply, indoor plants, artificial lawns, drip irrigation, and vertical gardens."
        />
        <meta
          name="keywords"
          content="landscaping services, garden care, plant supply, indoor plants, artificial lawns, drip irrigation, vertical gardens, KRM Landscape"
        />
      </Helmet>


      {/* 🔑 PAGE WRAPPER – THIS IS CRITICAL */}
      <div className="services-page-wrapper">
        <main className="services-page">
          {/* Sidebar */}
          <aside className="services-sidebar">
            <Typography variant="h6" className="sidebar-title">
              Our Services
            </Typography>

            <List>
              {servicesData.map((service) => (
                <ListItem key={service.name} disablePadding>
                  <ListItemButton component={Link} to={service.path}>
                    <ListItemText primary={service.name} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </aside>

          {/* Content */}
          <section className="services-content">
            <Typography variant="h4" className="services-heading" marginBottom={3}>
              Services Overview
            </Typography>

            <div className="services-grid">
              {servicesData.map((service) => (
                <Card key={service.name} className="service-card">
                  <CardMedia
                    component="img"
                    height="180"
                    image={service.image}
                    alt={service.name}
                  />
                  <CardContent>
                    <Typography variant="h6" className="service-title">
                      {service.name}
                    </Typography>
                    <Typography variant="body2">
                      {service.description}
                    </Typography>
                  </CardContent>
                  <div className="service-btn">
                    <Button
                      component={Link}
                      to={service.path}
                      variant="contained"
                    >
                      Learn More
                    </Button>
                  </div>
                </Card>
              ))}
            </div>
          </section>
        </main>
      </div>
    </>
  );
};

export default Services;
